import { TENANT_TYPE } from '@components/Ackodrive/common/constants'

export const EVENTS = {
  [TENANT_TYPE.ABOUTUS]: {
    view: {
      eventname: 'view_landing_page',
      eventProps: { version: 'wrapper_v1', funnel: 'visit', page_type: 'about us' },
    },
    scroll: {
      eventname: 'view_user_scroll',
      eventProps: { page_type: 'about us' },
    },
    engage: {
      eventname: 'tap_btn_engage',
      eventProps: { page_type: 'about us', journey: 'stories' },
    },
  },
  [TENANT_TYPE.BRANDHUB]: {
    view: {
      eventname: 'view_page',
      eventProps: {
        version: 'wrapper_v1',
        funnel: 'visit',
        page_type: 'brand_hub',
        product: 'brand_hub',
        journey: 'brand_hub',
      },
    },
    scroll: {
      eventname: 'view_user_scroll',
      eventProps: { page_type: 'brand_hub', product: 'brand_hub' },
    },
    engage: {
      eventname: 'tap_btn_CTA_widget',
      eventProps: { page_type: 'brand_hub', journey: 'brand_hub', product: 'brand_hub' },
    },
  },
  [TENANT_TYPE.MEDIAKIT]: {
    view: {
      eventname: 'view_page',
      eventProps: {
        version: 'wrapper_v1',
        funnel: 'visit',
        page_type: 'media_kit',
        product: 'media_kit',
        journey: 'media_kit',
      },
    },
    scroll: {
      eventname: 'view_user_scroll',
      eventProps: { page_type: 'media_kit', product: 'media_kit' },
    },
    engage: {
      eventname: 'tap_btn_CTA_widget',
      eventProps: { page_type: 'media_kit', journey: 'media_kit', product: 'media_kit' },
    },
  },
  [TENANT_TYPE.REVIEWS_TESTIMONIAL]: {
    view: {
      eventname: 'view_page',
      eventProps: {
        version: 'wrapper_v1',
        funnel: 'visit',
        page_type: 'customer_stories',
        product: 'customer_stories',
        journey: 'customer_stories',
      },
    },
    scroll: {
      eventname: 'view_user_scroll',
      eventProps: { page_type: 'customer_stories', product: 'customer_stories' },
    },
    engage: {
      eventname: 'tap_btn_CTA_widget',
      eventProps: { page_type: 'customer_stories', journey: 'customer_stories', product: 'customer_stories' },
    },
  },
  [TENANT_TYPE.DHONI_PRESS_RELEASE]: {
    view: {
      eventname: 'view_page',
      eventProps: {
        version: 'wrapper_v1',
        funnel: 'visit',
        page_type: 'dhoni_press_release',
        product: 'dhoni_press_release',
        journey: 'dhoni_press_release',
      },
    },
    scroll: {
      eventname: 'view_user_scroll',
      eventProps: { page_type: 'dhoni_press_release', product: 'dhoni_press_release' },
    },
  },
  [TENANT_TYPE.TESLA_TEST_DRIVE_BOOKING]: {
    view: {
      eventname: 'view_page',
      eventProps: {
        page_type: 'tesla_acko_exp_landing',
        product: 'tesla_acko_exp_landing',
        journey: 'tesla_acko_exp_landing',
      },
    },
    engage: {
      eventname: 'tap_btn_CTA_widget',
      eventProps: {
        page_type: 'tesla_acko_exp_landing',
        product: 'tesla_acko_exp_landing',
        journey: 'tesla_acko_exp_jan2026',
      },
    },
    modalView: {
      eventname: 'view_page',
      eventProps: {
        page_type: 'tesla_acko_exp_confirmed',
        product: 'tesla_acko_exp_confirmed',
        journey: 'tesla_acko_exp_confirmed',
      },
    },
  },
}
